import React from 'react';
import { Link } from 'react-router-dom';
import logoDark from '../../assets/images/logo_dark.png';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="relative bg-gradient-to-b from-gray-900 via-gray-900 to-purple-900 text-gray-300 pt-10">
            {/* Gradient Overlay */}
            <div className="absolute inset-0 bg-gradient-to-b from-transparent via-gray-900/50 to-purple-900/50 rounded-t-[100px]"></div>

            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                {/* First Row */}
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
                    {/* Logo Section */}
                    <div className="flex flex-col items-start">
                        <Link to="/">
                            <img
                                src={logoDark}
                                alt="Nexgen Learning Logo"
                                className="h-12 w-auto mb-4"
                            />
                        </Link>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h3 className="text-white text-lg font-semibold mb-4">Quick Links</h3>
                        <ul className="space-y-3">
                            <li>
                                <Link to="/about" className="hover:text-white transition-colors duration-200">
                                    About
                                </Link>
                            </li>
                            <li>
                                <Link to="/contact" className="hover:text-white transition-colors duration-200">
                                    Contact
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Contact Info */}
                    <div>
                        <h3 className="text-white text-lg font-semibold mb-4">Contact Info</h3>
                        <ul className="space-y-3">
                            <li className="flex items-start">
                                <svg className="h-6 w-6 mr-2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                </svg>
                                <span>Kenilworth NJ 07033</span>
                            </li>
                            <li className="flex items-start">
                                <svg className="h-6 w-6 mr-2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
                                </svg>
                                <a href="https://www.nexgen-learning.com" className="hover:text-white transition-colors duration-200" target="_blank" rel="noopener noreferrer">
                                    www.nexgen-learning.com
                                </a>
                            </li>
                        </ul>
                    </div>

                    {/* Newsletter Section */}
                    <div>
                        <h3 className="text-white text-lg font-semibold mb-4">Join Our Newsletter</h3>
                        <p className="text-gray-400 mb-4">
                            Get the latest updates and exclusive offers by subscribing to our newsletter!
                        </p>
                        <div className="flex flex-col sm:flex-row gap-2">
                            <input
                                type="email"
                                placeholder="Email Address"
                                className="px-4 py-2 rounded-lg bg-gray-800 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                            <button className="px-6 py-2 btn-primary text-white rounded-lg hover:bg-indigo-600 transition-colors duration-200">
                                Subscribe
                            </button>
                        </div>
                    </div>
                </div>

                {/* Second Row - Copyright */}
                <div className="border-t border-gray-800 pt-8">
                    <div className="text-center">
                        <p className="text-sm">
                            &copy; {currentYear} Nexgen Learning. All Rights Reserved.
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
